import React, { Suspense } from "react";

import { Switch, Route } from "react-router-dom";
import { GuardedRoute } from "react-router-guards";

import { ProgressSpinner } from "primereact/progressspinner";

import { useAuthGlobal } from "../../../contexts/auth-context/auth-context";

import createDiscriminatorEnv from "./utils/create-discriminator-env";

interface Page {
  path: string;
  component: React.FC;
  meta?: React.FC;
  exact?: boolean;
}

interface RouteConfig {
  layout: React.FC;
  pages: Page[];
}

interface RouteFactoryProps {
  routes: RouteConfig[];
}

export const RouteFactory: React.FC<RouteFactoryProps> = ({ routes }) => {
  const isMobileScreen = window.innerWidth < 768;
  const { user } = useAuthGlobal();

  const discriminatorEnv = createDiscriminatorEnv(isMobileScreen, user);

  return (
    <Switch>
      {routes.map(({ layout: Layout, pages }) => (
        <Route
          key={pages.map((page) => page.path).join()}
          path={pages.map((page) => page.path)}
        >
          <Layout>
            <Suspense fallback={<ProgressSpinner />}>
              <Switch>
                {pages.map(({ path, component, ...page }) => (
                  <GuardedRoute
                    guards={[discriminatorEnv]}
                    key={path}
                    path={path}
                    component={component}
                    {...page}
                    exact={page.exact ?? true}
                  />
                ))}
              </Switch>
            </Suspense>
          </Layout>
        </Route>
      ))}
    </Switch>
  );
};
